webpackJsonp([51379990262569],{

/***/ 1095:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(8);
	
	var _pragmaticForms = __webpack_require__(60);
	
	var _formManager = __webpack_require__(106);
	
	var _link = __webpack_require__(9);
	
	var _globalStyles = __webpack_require__(4);
	
	var _detail = __webpack_require__(378);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HoldAFundraiserPage = function (_React$PureComponent) {
		_inherits(HoldAFundraiserPage, _React$PureComponent);
	
		function HoldAFundraiserPage() {
			var _this2 = this;
	
			var _temp, _this, _ret;
	
			_classCallCheck(this, HoldAFundraiserPage);
	
			for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
				args[_key] = arguments[_key];
			}
	
			return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args))), _this), _this.state = {
				hasSubmitted: false
			}, _this.HoldAFundraiserForm = (0, _pragmaticForms.configureForm)({
				initFields: function initFields() {
					return {
						'form-name': 'hold-a-fundraiser',
						botField: '',
						firstName: '',
						lastName: '',
						email: '',
						message: ''
					};
				},
				validate: function validate(_ref) {
					var firstName = _ref.firstName,
					    lastName = _ref.lastName,
					    email = _ref.email,
					    message = _ref.message;
	
					var errors = {};
					if (!firstName) errors.firstName = 'Please enter your First Name';
					if (!lastName) errors.lastName = 'Please enter your Last Name';
					if (!email) errors.email = 'Please enter an Email Address';
					if (!message) errors.message = 'Please enter a Message';
					return errors;
				},
				submit: function () {
					var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(formData) {
						return regeneratorRuntime.wrap(function _callee$(_context) {
							while (1) {
								switch (_context.prev = _context.next) {
									case 0:
										_context.prev = 0;
										_context.next = 3;
										return fetch('/', {
											method: 'POST',
											body: (0, _formManager.encode)(formData)
										});
	
									case 3:
	
										_this.setState({ hasSubmitted: true });
										_context.next = 9;
										break;
	
									case 6:
										_context.prev = 6;
										_context.t0 = _context['catch'](0);
	
										console.error(_context.t0);
	
									case 9:
									case 'end':
										return _context.stop();
								}
							}
						}, _callee, _this2, [[0, 6]]);
					}));
	
					return function submit(_x) {
						return _ref2.apply(this, arguments);
					};
				}()
			})(function (_ref3) {
				var form = _ref3.form;
				return _react2.default.createElement(
					form.Form,
					{ netlify: 'true', name: 'hold-a-fundraiser', 'netlify-honeypot': 'botField' },
					_react2.default.createElement(
						'div',
						{ className: _globalStyles.formSection.wrapper },
						_react2.default.createElement(
							'p',
							{ style: { display: 'none' } },
							_react2.default.createElement(
								'label',
								null,
								'Don\u2019t fill this out if you\'re human:',
								_react2.default.createElement('input', form.getInputProps({ name: 'botField', type: 'text' }))
							)
						),
						_react2.default.createElement(
							'div',
							{ 'aria-live': 'assertive' },
							form.submitError && _react2.default.createElement(
								'p',
								{ className: _globalStyles.formSection.validationMessage },
								'Error: ',
								form.submitError
							),
							form.hasErrors && _react2.default.createElement(
								'ul',
								{ className: _globalStyles.formSection.validationSummary },
								Object.keys(form.errors).map(function (key) {
									return _react2.default.createElement(
										'li',
										{ key: key, className: _globalStyles.formSection.validationMessage },
										'' + form.errors[key]
									);
								})
							)
						),
						_react2.default.createElement(
							'div',
							{ className: _globalStyles.formSection.halfWidthWrapper },
							_react2.default.createElement(
								'div',
								{ className: _globalStyles.formSection.field },
								form.errors['firstName'] && _react2.default.createElement(
									'p',
									{ className: _globalStyles.formSection.validationFieldMessage },
									form.errors['firstName']
								),
								_react2.default.createElement(
									'label',
									{ htmlFor: 'firstName' },
									'First Name'
								),
								_react2.default.createElement('input', _extends({ id: 'firstName' }, form.getInputProps({ name: 'firstName', type: 'text' })))
							),
							_react2.default.createElement(
								'div',
								{ className: _globalStyles.formSection.field },
								form.errors['lastName'] && _react2.default.createElement(
									'p',
									{ className: _globalStyles.formSection.validationFieldMessage },
									form.errors['lastName']
								),
								_react2.default.createElement(
									'label',
									{ htmlFor: 'lastName' },
									'Last Name'
								),
								_react2.default.createElement('input', _extends({ id: 'lastName' }, form.getInputProps({ name: 'lastName', type: 'text' })))
							)
						),
						_react2.default.createElement(
							'div',
							{ className: _globalStyles.formSection.field },
							form.errors['email'] && _react2.default.createElement(
								'p',
								{ className: _globalStyles.formSection.validationFieldMessage },
								form.errors['email']
							),
							_react2.default.createElement(
								'label',
								{ htmlFor: 'emailAddress' },
								'Email Address'
							),
							_react2.default.createElement('input', _extends({ id: 'emailAddress' }, form.getInputProps({ name: 'email', type: 'text' })))
						),
						_react2.default.createElement(
							'div',
							{ className: _globalStyles.formSection.field },
							form.errors['message'] && _react2.default.createElement(
								'p',
								{ className: _globalStyles.formSection.validationFieldMessage },
								form.errors['message']
							),
							_react2.default.createElement(
								'label',
								{ htmlFor: 'message' },
								'Message'
							),
							_react2.default.createElement('textarea', _extends({
								className: _detail.holdAFundraiserTextareaStyle,
								id: 'message'
							}, form.getInputProps({ name: 'message' })))
						),
						_react2.default.createElement(
							'button',
							{
								className: _globalStyles.formSection.submitButton,
								type: 'submit',
								disabled: form.hasErrors || form.isLoading
							},
							'Send Message'
						)
					)
				);
			}), _temp), _possibleConstructorReturn(_this, _ret);
		}
	
		HoldAFundraiserPage.prototype.render = function render() {
			var pageSettings = this.props.data.page.edges[0].node;
	
			return _react2.default.createElement(
				'section',
				{ className: _detail.wrapperStyle },
				_react2.default.createElement(
					_reactHelmet.Helmet,
					{ title: 'Hold a Fundraiser' },
					_react2.default.createElement('meta', { property: 'og:type', content: 'website' }),
					_react2.default.createElement('meta', { property: 'og:title', content: 'Hold a Fundraiser' }),
					_react2.default.createElement('meta', { name: 'description', content: 'Fundraising for InsideOut is a great way to make a tangible difference to the lives of Australians living with, or affect by eating disorders.' }),
					_react2.default.createElement('meta', { property: 'og:description', content: 'Fundraising for InsideOut is a great way to make a tangible difference to the lives of Australians living with, or affect by eating disorders.' })
				),
				_react2.default.createElement(
					'div',
					{ className: _detail.innerWrapperStyle },
					_react2.default.createElement(
						'div',
						{ className: _globalStyles.detailSideBarLayout.wrapper },
						_react2.default.createElement(
							'div',
							{ className: _globalStyles.detailSideBarLayout.leftSide },
							_react2.default.createElement(
								'div',
								{ className: (0, _globalStyles.contentSection)('#fff') },
								!this.state.hasSubmitted && _react2.default.createElement(
									_react2.default.Fragment,
									null,
									_react2.default.createElement(
										'header',
										null,
										_react2.default.createElement(
											'h1',
											{ className: _detail.titleStyle },
											pageSettings.heading
										)
									),
									_react2.default.createElement('div', {
										className: _detail.textStyle,
										dangerouslySetInnerHTML: { __html: pageSettings.body }
									}),
									_react2.default.createElement(
										'div',
										{ className: _detail.holdAFundraiserFormWrapperStyle },
										_react2.default.createElement(this.HoldAFundraiserForm, null)
									)
								),
								this.state.hasSubmitted && _react2.default.createElement(
									_react2.default.Fragment,
									null,
									_react2.default.createElement(
										'header',
										null,
										_react2.default.createElement(
											'h1',
											{ className: _detail.titleStyle },
											pageSettings.thank_you_heading
										)
									),
									_react2.default.createElement('div', {
										className: _detail.textStyle,
										dangerouslySetInnerHTML: {
											__html: pageSettings.thank_you_body
										}
									}),
									_react2.default.createElement(
										'div',
										{ className: (0, _globalStyles.contentSection)('#fff') },
										_react2.default.createElement(
											_link.Link,
											{ className: (0, _globalStyles.button)(_globalStyles.pink), to: pageSettings.thank_you_button_url },
											pageSettings.thank_you_button_text
										)
									)
								)
							)
						)
					)
				)
			);
		};
	
		return HoldAFundraiserPage;
	}(_react2.default.PureComponent);
	
	HoldAFundraiserPage.propTypes = {
		data: _propTypes2.default.shape({
			page: _propTypes2.default.shape({
				edges: _propTypes2.default.arrayOf(_propTypes2.default.shape({
					node: _propTypes2.default.shape({
						heading: _propTypes2.default.string.isRequired,
						body: _propTypes2.default.string.isRequired
					}).isRequired
				})).isRequired
			}).isRequired
		}).isRequired
	};
	exports.default = HoldAFundraiserPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-get-involved-hold-a-fundraiser-index-js-8ff58418ad2679a22d07.js